module.exports = __webpack_public_path__ + "img/ricelog_pinicon_090.34879c8b.png";